import script from "./TimeField.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeField.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField,QIcon});
